'use client';

import { Container } from '@/layers/presentation/components/common/Container';
import ProgramSearchFilters from '@/layers/presentation/components/programs/ProgramSearchFilters';
import ProgramsList from '@/layers/presentation/components/programs/ProgramsList';
import SubscriptionPrompt from '@/layers/presentation/components/ui/SubscriptionPrompt';
import { useProgramSearch } from '@/layers/presentation/hooks';
import logger from '@/layers/support/monitoring/logger';
import { UserType } from '@/types/modelEnums';

const LOG_MODULE = '[Pages / Patient / Search Programs]';

/**
 * Client-side portion of the patient program search page.
 * Extracted verbatim from the original `page.tsx` so the server parent can
 * own metadata + SSR copy for SEO. See T-0108 plan step 5.
 */
export default function PatientSearchProgramClient() {
  const {
    selectedOptions,
    query,
    handleParamChange,
    handleQueryChange,
    handleSaveSearch,
    initialSettleReady,
    uiFiltersStrict,
    listFilters,
  } = useProgramSearch();

  logger.debug(`${LOG_MODULE} Render`, { selectedOptions, query });

  return (
    <>
      <Container>
        <ProgramSearchFilters
          filters={uiFiltersStrict}
          onParamChange={handleParamChange}
          onQueryChange={handleQueryChange}
        />
        <ProgramsList
          type={UserType.PATIENT}
          filters={listFilters}
          onSaveSearch={handleSaveSearch}
          showDefaultRecent={true}
          ready={initialSettleReady}
        />
      </Container>
      <SubscriptionPrompt
        prompt={{
          title: 'Get Treatment Updates Straight to Your Email',
          text: 'Right2Hope will also continue searching for new matching programs and will notify you via email as soon as they become available.',
          button: 'Subscribe to Updates',
        }}
        modal={{
          title: 'Get Treatment Updates Straight to Your Email',
          text: 'Right2Hope will also continue searching for new matching programs and will notify you via email as soon as they become available.',
          button: 'Subscribe Now',
        }}
        params={{
          query,
          patientParams: selectedOptions || {},
          userType: UserType.PATIENT,
        }}
        background="bg-[#e7e1d5]"
      />
    </>
  );
}
